import React from 'react';

import { SectionLayoutDetails, SectionsLayoutMap } from './layouts';

export type GridSectionsContextValue = {
  sectionLayoutsDetailsMap: SectionsLayoutMap;
  getLayoutPixelHeight: (layoutRows: number) => number;
  singleColumnView: boolean;
  isDraggingSection: boolean;
};

export const GridSectionsContext = React.createContext<GridSectionsContextValue | undefined>(
  undefined,
);

export function useGridSectionContext(sectionKey: string): {
  sectionDetails: SectionLayoutDetails | undefined;
  getLayoutPixelHeight: GridSectionsContextValue['getLayoutPixelHeight'];
  singleColumnView: boolean;
  isDraggingSection: boolean;
} {
  const { sectionLayoutsDetailsMap, getLayoutPixelHeight, singleColumnView, isDraggingSection } =
    React.useContext(GridSectionsContext) ??
    (() => {
      throw new Error('useGridSectionContext called without GridSectionsContext');
    })();

  return {
    sectionDetails: sectionLayoutsDetailsMap?.[sectionKey],
    getLayoutPixelHeight,
    singleColumnView,
    isDraggingSection,
  };
}
